import React, { useEffect, useState } from 'react'
import { Panel, Row, Col, Input, InputNumber, CheckPicker } from 'rsuite'
import SearchButton from '../../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'

export default function ListReportIssuesSearchForm({
  schema,
  loading,
  onSearch = () => {},
  errors,
  error,
  Controller,
  control,
  setValue,
  clearErrors,
  onExport,
  isExport,
  ...props
}) {
  const [contractNumber, setContractNumber] = useState()
  const [projectCode, setProjectCode] = useState()
  const [projectName, setProjectName] = useState()
  const [organizationName, setOrganizationName] = useState()
  const [granteeName, setGranteeName] = useState()
  const [responsibleName, setResponsibleName] = useState()
  const [budgetStart, setBudgetStart] = useState(0)
  const [budgetEnd, setBudgetEnd] = useState(0)
  const [department, setDepartment] = useState()
  const [coordinator, setCoordinator] = useState()
  const [auditTeam, setAuditTeam] = useState()
  const [projectGrade, setProjectGrade] = useState()
  const [auditResult, setAuditResult] = useState()
  const [issueCategory, setIssueCategory] = useState()
  const [issue, setIssue] = useState()
  const [riskType, setRiskType] = useState()
  const [trackingResults, setTrackingResults] = useState()
  const [status, setStatus] = useState()
  const [step, setStep] = useState()
  const [budgetYear, setBudgetYear] = useState()

  const colStyle = {
    //marginTop: '5px',
    padding: '8px',
    textAlign: 'right',
  }

  useEffect(() => {
    console.log('isExport')
    if (isExport) {
      let request = {
        contractNumber: contractNumber || '',
        projectCode: projectCode || '',
        projectName: projectName || '',
        organizationName: organizationName || '',
        granteeName: granteeName || '',
        responsibleName: responsibleName || '',
        budgetStart: budgetStart || null,
        budgetEnd: budgetEnd || null,
        department: department || [],
        coordinator: coordinator || '',
        auditTeam: auditTeam || '',
        projectGrade: projectGrade || [],
        auditResult: auditResult || [],
        issueCategory: issueCategory || [],
        issue: issue || [],
        riskType: riskType || [],
        trackingResults: trackingResults || [],
        status: status || [],
        step: step || [],
        budgetYear: budgetYear || [],
      }

      onExport(request)
    }
  }, [isExport])

  const handleSearch = () => {
    let request = {
      contractNumber: contractNumber || '',
      projectCode: projectCode || '',
      projectName: projectName || '',
      organizationName: organizationName || '',
      granteeName: granteeName || '',
      responsibleName: responsibleName || '',
      budgetStart: budgetStart || null,
      budgetEnd: budgetEnd || null,
      department: department || [],
      coordinator: coordinator || '',
      auditTeam: auditTeam || '',
      projectGrade: projectGrade || [],
      auditResult: auditResult || [],
      issueCategory: issueCategory || [],
      issue: issue || [],
      riskType: riskType || [],
      trackingResults: trackingResults || [],
      status: status || [],
      step: step || [],
      budgetYear: budgetYear || [],
    }
    onSearch(request)
  }

  const handleCancel = () => {
    setContractNumber('')
    setProjectCode('')
    setProjectName('')
    setOrganizationName('')
    setGranteeName('')
    setResponsibleName('')
    setBudgetStart(0)
    setBudgetEnd(0)
    setDepartment([])
    setCoordinator(null)
    setAuditTeam('')
    setProjectGrade([])
    setAuditResult([])
    setIssueCategory([])
    setIssue([])
    setRiskType([])
    setTrackingResults([])
    setStatus([])
    setStep([])
    setBudgetYear([])
    let request = {
      contractNumber: '',
      projectCode: '',
      projectName: '',
      organizationName: '',
      granteeName: '',
      responsibleName: '',
      budgetStart: null,
      budgetEnd: null,
      department: [],
      coordinator: '',
      auditTeam: '',
      projectGrade: [],
      auditResult: [],
      issueCategory: [],
      issue: [],
      riskType: [],
      trackingResults: [],
      status: [],
      step: [],
      budgetYear: [],
    }
    onSearch(request)
  }

  return (
    <>
      <Panel header={'ค้นหา'} bordered collapsible defaultExpanded>
        <Row>
          {/* เลขที่สัญญา */}
          {/* 
          {schema.contractNumber && (
            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.contractNumber.label}
              <Input
                placeholder={schema.contractNumber.hint || schema.contractNumber.label}
                value={contractNumber}
                onChange={(value) => {
                  setContractNumber(value)
                }}
              />
            </Col>
          )} */}
          {schema.contractNumber && (
            <>
              <Col lg={5} md={5} sm={8} xs={8} style={colStyle}>
                {schema.contractNumber.label} :
              </Col>

              <Col lg={7} md={7} sm={16} xs={16} style={colStyle}>
                <Input
                  placeholder={schema.contractNumber.hint || schema.contractNumber.label}
                  value={contractNumber}
                  onChange={(value) => {
                    setContractNumber(value)
                  }}
                />
              </Col>
            </>
          )}

          {/* รหัสโครงการ */}
          {schema.projectCode && (
            <>
              <Col lg={5} md={5} sm={8} xs={8} style={colStyle}>
                {schema.projectCode.label} :
              </Col>

              <Col lg={7} md={7} sm={16} xs={16} style={colStyle}>
                <Input
                  placeholder={schema.projectCode.hint || schema.projectCode.label}
                  value={projectCode}
                  onChange={(value) => {
                    setProjectCode(value)
                  }}
                />
              </Col>
            </>
          )}
        </Row>

        <Row>
          {/* ชื่อโครงการ */}
          {schema.projectName && (
            <>
              <Col lg={5} md={5} sm={8} xs={8} style={colStyle}>
                {schema.projectName.label} :
              </Col>

              <Col lg={7} md={7} sm={16} xs={16} style={colStyle}>
                <Input
                  placeholder={schema.projectName.hint || schema.projectName.label}
                  value={projectName}
                  onChange={(value) => {
                    setProjectName(value)
                  }}
                />
              </Col>
            </>
          )}

          {/* องค์กรรับทุน */}
          {schema.organizationName && (
            <>
              <Col lg={5} md={5} sm={8} xs={8} style={colStyle}>
                {schema.organizationName.label} :
              </Col>

              <Col lg={7} md={7} sm={16} xs={16} style={colStyle}>
                <Input
                  placeholder={schema.organizationName.hint || schema.organizationName.label}
                  value={organizationName}
                  onChange={(value) => {
                    setOrganizationName(value)
                  }}
                />
              </Col>
            </>
          )}
        </Row>

        <Row>
          {/* ผู้รับทุน */}
          {schema.granteeName && (
            <>
              <Col lg={5} md={5} sm={8} xs={8} style={colStyle}>
                {schema.granteeName.label} :
              </Col>

              <Col lg={7} md={7} sm={16} xs={16} style={colStyle}>
                <Input
                  placeholder={schema.granteeName.hint || schema.granteeName.label}
                  value={granteeName}
                  onChange={(value) => {
                    setGranteeName(value)
                  }}
                />
              </Col>
            </>
          )}
          {/* ผู้รับผิดชอบโครงการ */}
          {schema.responsibleName && (
            <>
              <Col lg={5} md={5} sm={8} xs={8} style={colStyle}>
                {schema.responsibleName.label} :
              </Col>

              <Col lg={7} md={7} sm={16} xs={16} style={colStyle}>
                <Input
                  placeholder={schema.responsibleName.hint || schema.responsibleName.label}
                  value={responsibleName}
                  onChange={(value) => {
                    setResponsibleName(value)
                  }}
                />
              </Col>
            </>
          )}
        </Row>

        <Row>
          {/* งบอนุมัติตั้งแต่ */}
          {schema.budgetStart && (
            <>
              <Col lg={5} md={5} sm={8} xs={8} style={colStyle}>
                {schema.budgetStart.label} :
              </Col>

              <Col lg={7} md={7} sm={16} xs={16} style={colStyle}>
                <InputNumber
                  placeholder={schema.budgetStart.hint || schema.budgetStart.label}
                  value={budgetStart}
                  onChange={(value) => {
                    setBudgetStart(value)
                  }}
                />
              </Col>
            </>
          )}

          {/* งบอนุมัติจนถึง */}
          {schema.budgetEnd && (
            <>
              <Col lg={5} md={5} sm={8} xs={8} style={colStyle}>
                {schema.budgetEnd.label} :
              </Col>

              <Col lg={7} md={7} sm={16} xs={16} style={colStyle}>
                <InputNumber
                  placeholder={schema.budgetEnd.hint || schema.budgetEnd.label}
                  value={budgetEnd}
                  onChange={(value) => {
                    setBudgetEnd(value)
                  }}
                />
              </Col>
            </>
          )}
        </Row>

        <Row>
          {/* สำนัก */}
          {schema.department && (
            <>
              <Col lg={5} md={5} sm={8} xs={8} style={colStyle}>
                {schema.department.label} :
              </Col>

              <Col lg={7} md={7} sm={16} xs={16} style={colStyle}>
                <Controller
                  name={schema.department.name}
                  control={control}
                  defaultValue={schema.department.value}
                  // rules={isValidators(schema.department.validators)}
                  render={(props) => {
                    return (
                      <CheckPicker
                        sticky={schema.department.options.length > 6 ? true : false}
                        data={schema.department.options}
                        defaultValue={schema.department.defaultValue}
                        // value={props.value}
                        value={department}
                        block
                        placeholder="เลือก"
                        onChange={(value) => {
                          props.onChange(value)
                          setDepartment(value)
                        }}
                      />
                    )
                  }}
                />
                {/* <SelectPicker
                  virtualized={false}
                  searchable={false}
                  data={schema.department.options}
                  value={department}
                  block
                  placeholder={`เลือก${schema.department.label || ''}`}
                  onChange={(value) => {
                    setDepartment(value)
                  }}
                /> */}
              </Col>
            </>
          )}

          {/* นักวิชาการ */}
          {schema.coordinator && (
            <>
              <Col lg={5} md={5} sm={8} xs={8} style={colStyle}>
                {schema.coordinator.label} :
              </Col>

              <Col lg={7} md={7} sm={16} xs={16} style={colStyle}>
                <Input
                  placeholder={schema.coordinator.hint || schema.coordinator.label}
                  value={coordinator}
                  onChange={(value) => {
                    setCoordinator(value)
                  }}
                />
              </Col>
            </>
          )}
        </Row>

        <Row>
          {/* ทีมตรวจ (บริษัท) */}
          {schema.auditTeam && (
            <>
              <Col lg={5} md={5} sm={8} xs={8} style={colStyle}>
                {schema.auditTeam.label} :
              </Col>

              <Col lg={7} md={7} sm={16} xs={16} style={colStyle}>
                <Input
                  placeholder={schema.auditTeam.hint || schema.auditTeam.label}
                  value={auditTeam}
                  onChange={(value) => {
                    setAuditTeam(value)
                  }}
                />
              </Col>
            </>
          )}

          {/* เกรด */}
          {schema.projectGrade && (
            <>
              <Col lg={5} md={5} sm={8} xs={8} style={colStyle}>
                {schema.projectGrade.label} :
              </Col>

              <Col lg={7} md={7} sm={16} xs={16} style={colStyle}>
                <Controller
                  name={schema.projectGrade.name}
                  control={control}
                  defaultValue={schema.projectGrade.value}
                  // rules={isValidators(schema.projectGrade.validators)}
                  render={(props) => {
                    return (
                      <CheckPicker
                        sticky={schema.projectGrade.options.length > 6 ? true : false}
                        data={schema.projectGrade.options}
                        defaultValue={schema.projectGrade.defaultValue}
                        // value={props.value}
                        value={projectGrade}
                        block
                        placeholder="เลือก"
                        onChange={(value) => {
                          props.onChange(value)
                          setProjectGrade(value)
                        }}
                        searchable={false}
                      />
                    )
                  }}
                />
                {/* <SelectPicker
                  virtualized={false}
                  searchable={false}
                  data={schema.projectGrade.options}
                  value={projectGrade}
                  block
                  placeholder={`เลือก${schema.projectGrade.label || ''}`}
                  onChange={(value) => {
                    setProjectGrade(value)
                  }}
                /> */}
              </Col>
            </>
          )}
        </Row>

        <Row>
          {/* ผลการตรวจสอบ */}
          {schema.auditResult && (
            <>
              <Col lg={5} md={5} sm={8} xs={8} style={colStyle}>
                {schema.auditResult.label} :
              </Col>

              <Col lg={7} md={7} sm={16} xs={16} style={colStyle}>
                <Controller
                  name={schema.auditResult.name}
                  control={control}
                  defaultValue={schema.auditResult.value}
                  // rules={isValidators(schema.auditResult.validators)}
                  render={(props) => {
                    return (
                      <CheckPicker
                        sticky={schema.auditResult.options.length > 6 ? true : false}
                        data={schema.auditResult.options}
                        defaultValue={schema.auditResult.defaultValue}
                        // value={props.value}
                        value={auditResult}
                        block
                        placeholder="เลือก"
                        onChange={(value) => {
                          props.onChange(value)
                          setAuditResult(value)
                        }}
                        searchable={false}
                      />
                    )
                  }}
                />
                {/* <SelectPicker
                  virtualized={false}
                  searchable={false}
                  data={schema.auditResult.options}
                  value={auditResult}
                  block
                  placeholder={`เลือก${schema.auditResult.label || ''}`}
                  onChange={(value) => {
                    setAuditResult(value)
                  }}
                /> */}
              </Col>
            </>
          )}

          {/* ด้าน */}
          {schema.issueCategory && (
            <>
              <Col lg={5} md={5} sm={8} xs={8} style={colStyle}>
                {schema.issueCategory.label} :
              </Col>

              <Col lg={7} md={7} sm={16} xs={16} style={colStyle}>
                <Controller
                  name={schema.issueCategory.name}
                  control={control}
                  defaultValue={schema.issueCategory.value}
                  // rules={isValidators(schema.issueCategory.validators)}
                  render={(props) => {
                    return (
                      <CheckPicker
                        sticky={schema.issueCategory.options.length > 6 ? true : false}
                        data={schema.issueCategory.options}
                        defaultValue={schema.issueCategory.defaultValue}
                        // value={props.value}
                        value={issueCategory}
                        block
                        placeholder="เลือก"
                        onChange={(value) => {
                          props.onChange(value)
                          setIssueCategory(value)
                        }}
                        searchable={false}
                      />
                    )
                  }}
                />
                {/* <SelectPicker
                  virtualized={false}
                  searchable={false}
                  data={schema.issueCategory.options}
                  value={issueCategory}
                  block
                  placeholder={`เลือก${schema.issueCategory.label || ''}`}
                  onChange={(value) => {
                    setIssueCategory(value)
                  }}
                /> */}
              </Col>
            </>
          )}
        </Row>

        <Row>
          {/* ประเด็น */}
          {schema.issue && (
            <>
              <Col lg={5} md={5} sm={8} xs={8} style={colStyle}>
                {schema.issue.label} :
              </Col>

              <Col lg={7} md={7} sm={16} xs={16} style={colStyle}>
                <Controller
                  name={schema.issue.name}
                  control={control}
                  defaultValue={schema.issue.value}
                  // rules={isValidators(schema.issue.validators)}
                  render={(props) => {
                    return (
                      <CheckPicker
                        sticky={schema.issue.options.length > 6 ? true : false}
                        data={schema.issue.options}
                        defaultValue={schema.issue.defaultValue}
                        // value={props.value}
                        value={issue}
                        block
                        placeholder="เลือก"
                        onChange={(value) => {
                          props.onChange(value)
                          setIssue(value)
                        }}
                        virtualized={false}
                        renderMenuItem={(label, item) => {
                          return (
                            <span>
                              {item?.value} {label}
                            </span>
                          )
                        }}
                        renderValue={(value, item) => {
                          let values = item.map((e, index) => {
                            if (item.length == 1) {
                              return e.value
                            } else if (item.length - 1 == index) {
                              return e.value
                            } else {
                              return e.value + ', '
                            }
                          })

                          console.log('values', values)

                          return values
                        }}
                      />
                    )
                  }}
                />
                {/* <SelectPicker
                  virtualized={false}
                  searchable={false}
                  data={schema.issue.options}
                  value={issue}
                  block
                  placeholder={`เลือก${schema.issue.label || ''}`}
                  onChange={(value) => {
                    setIssue(value)
                  }}
                  renderMenuItem={(label, item) => {
                    return (
                      <span>
                        {item?.value} {label}
                      </span>
                    )
                  }}
                  renderValue={(value, item) => {
                    console.log(item)
                    return (
                      <span>
                        {item?.value} {item?.label}
                      </span>
                    )
                  }}
                /> */}
              </Col>
            </>
          )}

          {/* ความเสี่ยง */}
          {schema.riskType && (
            <>
              <Col lg={5} md={5} sm={8} xs={8} style={colStyle}>
                {schema.riskType.label} :
              </Col>

              <Col lg={7} md={7} sm={16} xs={16} style={colStyle}>
                <Controller
                  name={schema.riskType.name}
                  control={control}
                  defaultValue={schema.riskType.value}
                  // rules={isValidators(schema.riskType.validators)}
                  render={(props) => {
                    return (
                      <CheckPicker
                        sticky={schema.riskType.options.length > 6 ? true : false}
                        data={schema.riskType.options}
                        defaultValue={schema.riskType.defaultValue}
                        // value={props.value}
                        value={riskType}
                        block
                        placeholder="เลือก"
                        onChange={(value) => {
                          props.onChange(value)
                          setRiskType(value)
                        }}
                        searchable={false}
                      />
                    )
                  }}
                />
                {/* <SelectPicker
                  virtualized={false}
                  searchable={false}
                  data={schema.riskType.options}
                  value={riskType}
                  block
                  placeholder={`เลือก${schema.riskType.label || ''}`}
                  onChange={(value) => {
                    setRiskType(value)
                  }}
                /> */}
              </Col>
            </>
          )}
        </Row>

        <Row>
          {/* ผลการติดตามการดำเนินงาน */}
          {schema.trackingResults && (
            <>
              <Col lg={5} md={5} sm={8} xs={8} style={colStyle}>
                {schema.trackingResults.label} :
              </Col>

              <Col lg={7} md={7} sm={16} xs={16} style={colStyle}>
                <Controller
                  name={schema.trackingResults.name}
                  control={control}
                  defaultValue={schema.trackingResults.value}
                  // rules={isValidators(schema.trackingResults.validators)}
                  render={(props) => {
                    return (
                      <CheckPicker
                        sticky={schema.trackingResults.options.length > 6 ? true : false}
                        data={schema.trackingResults.options}
                        defaultValue={schema.trackingResults.defaultValue}
                        // value={props.value}
                        value={trackingResults}
                        block
                        placeholder="เลือก"
                        onChange={(value) => {
                          props.onChange(value)
                          setTrackingResults(value)
                        }}
                        searchable={false}
                      />
                    )
                  }}
                />
                {/* <SelectPicker
                  virtualized={false}
                  searchable={false}
                  data={schema.trackingResults.options}
                  value={trackingResults}
                  block
                  placeholder={`เลือก${schema.trackingResults.label || ''}`}
                  onChange={(value) => {
                    setTrackingResults(value)
                  }}
                  renderMenuItem={(label, item) => {
                    return <span dangerouslySetInnerHTML={{ __html: label }}></span>
                  }}
                  renderValue={(value, item) => {
                    console.log(item)
                    return <span dangerouslySetInnerHTML={{ __html: item?.label }}></span>
                  }}
                /> */}
              </Col>
            </>
          )}

          {/* สถานะการรายงานผล */}
          {schema.status && (
            <>
              <Col lg={5} md={5} sm={8} xs={8} style={colStyle}>
                {schema.status.label} :
              </Col>

              <Col lg={7} md={7} sm={16} xs={16} style={colStyle}>
                <Controller
                  name={schema.status.name}
                  control={control}
                  defaultValue={schema.status.value}
                  // rules={isValidators(schema.status.validators)}
                  render={(props) => {
                    return (
                      <CheckPicker
                        sticky={schema.status.options.length > 6 ? true : false}
                        data={schema.status.options}
                        defaultValue={schema.status.defaultValue}
                        // value={props.value}
                        value={status}
                        block
                        placeholder="เลือก"
                        onChange={(value) => {
                          props.onChange(value)
                          setStatus(value)
                        }}
                        searchable={false}
                      />
                    )
                  }}
                />
                {/* <SelectPicker
                  virtualized={false}
                  searchable={false}
                  data={schema.status.options}
                  value={status}
                  block
                  placeholder={`เลือก${schema.status.label || ''}`}
                  onChange={(value) => {
                    setStatus(value)
                  }}
                /> */}
              </Col>
            </>
          )}
        </Row>

        <Row>
          {/* สถานะการติดตามผล */}
          {schema.step && (
            <>
              <Col lg={5} md={5} sm={8} xs={8} style={colStyle}>
                {schema.step.label} :
              </Col>

              <Col lg={7} md={7} sm={16} xs={16} style={colStyle}>
                <Controller
                  name={schema.step.name}
                  control={control}
                  defaultValue={schema.step.value}
                  // rules={isValidators(schema.step.validators)}
                  render={(props) => {
                    return (
                      <CheckPicker
                        sticky={schema.step.options.length > 6 ? true : false}
                        data={schema.step.options}
                        defaultValue={schema.step.defaultValue}
                        // value={props.value}
                        value={step}
                        block
                        placeholder="เลือก"
                        onChange={(value) => {
                          props.onChange(value)
                          setStep(value)
                        }}
                        searchable={false}
                      />
                    )
                  }}
                />
              </Col>
            </>
          )}

          {/* ปีงบประมาณ */}
          {schema.budgetYear && (
            <>
              <Col lg={5} md={5} sm={8} xs={8} style={colStyle}>
                {schema.budgetYear.label} :
              </Col>

              <Col lg={7} md={7} sm={16} xs={16} style={colStyle}>
                <Controller
                  name={schema.budgetYear.name}
                  control={control}
                  defaultValue={schema.budgetYear.value}
                  // rules={isValidators(schema.budgetYear.validators)}
                  render={(props) => {
                    return (
                      <CheckPicker
                        sticky={schema.budgetYear.options.length > 6 ? true : false}
                        data={schema.budgetYear.options}
                        defaultValue={schema.budgetYear.defaultValue}
                        // value={props.value}
                        value={budgetYear}
                        block
                        placeholder="เลือก"
                        onChange={(value) => {
                          props.onChange(value)
                          setBudgetYear(value)
                        }}
                        searchable={false}
                      />
                    )
                  }}
                />
              </Col>
            </>
          )}
        </Row>

        <Row style={{ marginTop: 20 }}>
          {/* <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}></Col> */}
          <Col lg={8} md={8} sm={24} xs={24}>
            <SearchButton
              disabled={loading}
              onClick={() => {
                handleSearch()
              }}
              style={{ marginTop: 0, marginLeft: 0 }}
            >
              ค้นหา
            </SearchButton>
            <CancelButton
              onClick={() => {
                handleCancel()
              }}
              style={{ marginTop: 0, marginLeft: 10 }}
            >
              ยกเลิก
            </CancelButton>
          </Col>
        </Row>
      </Panel>
    </>
  )
}
